<template>

	
	<!-- page content -->
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-12 col-md-12 col-sm-12 mx-auto user-panel mb-5">

	
				<div class="row page-header">
					<div class="col">
						<h3>Active Users</h3>
					</div>
				</div>
				
                <div class="row">
                    <div class="col">
                        <table class="table mt-2">
                            <thead>
                                <tr>
                                    <th class="w-20">Name</th>
                                    <th class="w-10">Permissions</th>
                                    <th class="w-10">Access Method</th>
									<th class="w-10">Status</th>
									<th class="w-10">Version</th>
                                    <th class="w-10">Last Active</th>

                                </tr>
                            </thead>
                            <tbody>
								<tr v-for="user in users">
									<td><router-link :to="{ name: 'AdminUserDetails', params: { id: user.user_id }}">{{ user.name }}</router-link></td>
									<td>{{ user.role | displayRole}}</td>
									<td>{{ user.method }}</td>
									<td>
										<div class="badge badge-warning" v-if="determineIsIdle(user.last_active)">Idle</div>
										<div class="badge badge-success" v-if="!determineIsIdle(user.last_active)">Active</div>
									</td>
									<td>{{ user.version }}</td>
									<td>{{ user.last_active | timeAgo }}</td>
								</tr>
                            </tbody>
                        </table>
                    </div>
                </div>

			</div>
		</div>
	</div>

			
</template>

<script>

    import moment from 'moment';
	import * as Config from '../../../config'
    import { mapState, mapGetters } from 'vuex';

	export default {
		name: 'Users',
		data () {
			return {
				users: {},
				interval: null,
			}
		},
		mounted() {
            this.getUsers();
            
			this.interval = setInterval(function () {
                this.getUsers();
            }.bind(this), 5000);
		},
		methods: {
			...mapGetters([
                'getAuthorizationHeader',
            ]),
			getUsers() {
				var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/users/active", this.getAuthorizationHeader()).then((response) => {
                    _this.users = response.data
                });
			},
			determineIsIdle(time) {
				var date1 = moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss");
				// console.log(date1)
				var date2 = moment(time);
				// console.log(date2)
				var diff = date2.diff(date1, 'minutes');

				// console.log(Math.abs(diff))

				if(Math.abs(diff) > 5) {
					return true;
				}
				return false;
				
			}
		},
		beforeDestroy: function() {
            clearInterval(this.interval);
            console.log('cleared interval')
        },
		filters: {
			displayRole: function(data) {
				if(data == 'videographer') {
					return 'Videographer'
				} else if (data == 'media_purchaser') {
					return 'Media Purchaser'
				} else if (data == 'media_producer') {
					return 'Media Producer'
				} else if (data == 'administrator') {
					return 'Administrator'
				} else if (data == 'superadministrator') {
					return 'Super Administrator'
				}
            },
            timeAgo: function(date) {
                return moment.utc(date).fromNow();
            },
		}
	}
</script>

<style scoped>

</style>
